import { render, staticRenderFns } from "./DomainBookables.vue?vue&type=template&id=134d57ae&scoped=true&"
import script from "./DomainBookables.vue?vue&type=script&lang=js&"
export * from "./DomainBookables.vue?vue&type=script&lang=js&"
import style0 from "./DomainBookables.vue?vue&type=style&index=0&id=134d57ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d57ae",
  null
  
)

export default component.exports